import { call, put, takeLatest } from "redux-saga/effects";
import {
  getGlobalStatsSuccess,
  getGlobalStatsFailure,
} from "./GlobalStats.actions";
import { GlobalStatsService } from "./GlobalStats.store";

function delay(duration) {
  const promise = new Promise((resolve) => {
    setTimeout(() => resolve(true), duration);
  });
  return promise;
}

function* globalStatsSaga(args) {
  const { doUpdate: isUpdating } = args;
  let doUpdate = isUpdating;
  if (doUpdate) {
    while (doUpdate) {
      try {
        const globalStatsService = new GlobalStatsService();
        const data = yield call(globalStatsService.fetchGlobalStats);
        yield put(getGlobalStatsSuccess(data));
        yield call(delay, 10000);
      } catch (error) {
        doUpdate = false;
        yield put(getGlobalStatsFailure(error));
      }
    }
  } else {
    try {
      const globalStatsService = new GlobalStatsService();
      const data = yield call(globalStatsService.fetchGlobalStats);
      yield put(getGlobalStatsSuccess(data));
      yield call(delay, 10000);
    } catch (error) {
      doUpdate = false;
      yield put(getGlobalStatsFailure(error));
    }
  }
}

export function* globalStatsSagas() {
  const GET_GLOBALSTATS = "GET_GLOBALSTATS";
  yield takeLatest(GET_GLOBALSTATS, globalStatsSaga);
}
